// src/services/api/smsConfig.js
import { apiClient } from './base';

const BASE = '/sms-config';

export const getSmsGateways = () => apiClient.get(`${BASE}/gateways`).then(r => r.data);
export const getBusinessSmsConfig = () => apiClient.get(BASE).then(r => r.data);
export const createBusinessSmsConfig = (data) => apiClient.post(BASE, data).then(r => r.data);
export const updateBusinessSmsConfig = (data) => apiClient.put(BASE, data).then(r => r.data);
export const deleteBusinessSmsConfig = () => apiClient.delete(BASE).then(r => r.data);

export const getSmsTriggers = () => apiClient.get(`${BASE}/triggers`).then(r => r.data);
export const createSmsTrigger = (data) => apiClient.post(`${BASE}/triggers`, data).then(r => r.data);
export const updateSmsTrigger = (id, data) => apiClient.put(`${BASE}/triggers/${id}`, data).then(r => r.data);
export const deleteSmsTrigger = (id) => apiClient.delete(`${BASE}/triggers/${id}`).then(r => r.data);

export const getTriggerOptions = () => apiClient.get(`${BASE}/trigger-options`).then(r => r.data);

export const sendTestSms = (data) => apiClient.post(`${BASE}/test`, data).then(r => r.data);

export const getSmsLogs = ({ page = 1, pageSize = 20 } = {}) =>
  apiClient.get(`${BASE}/logs`, { params: { page, pageSize } }).then(r => r.data);